import React from 'react';
import { FiMonitor, FiZap, FiShield } from 'react-icons/fi';
import { FaHandshake } from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <div className="about-page" style={{ paddingTop: '6rem', minHeight: '85vh' }}>
      <div className="fintech-container">
        <div className="about-hero">
          <span className="section-eyebrow">ABOUT KUBERSETU INFOTECH</span>
          <h1 className="gradient-text">Engineering Digital Growth Through Custom Technology</h1>
          <p className="about-hero-desc">
            Kubersetu Infotech Private Limited is a premier technology & software engineering company specializing in custom web applications, mobile apps (iOS & Android), fintech software solutions, and cloud infrastructure.
          </p>
        </div>

        <div className="about-content">
          <div className="bento-grid">
            <div className="bento-box col-span-2">
              <h2 style={{ fontSize: '1.75rem', marginBottom: '1rem' }}>Our Story & Mission</h2>
              <p style={{ color: 'var(--text-muted)', lineHeight: '1.7', marginBottom: '1rem' }}>
                Founded with a mission to empower startups, businesses, and enterprises with world-class digital products, Kubersetu Infotech bridges the gap between complex business requirements and modern software architecture.
              </p>
              <p style={{ color: 'var(--text-muted)', lineHeight: '1.7' }}>
                Our team of senior software engineers, UI/UX designers, and cloud architects build scalable web and mobile software tailored for high performance, sub-second response times, and bank-grade security.
              </p>
            </div>

            <div className="bento-box col-span-2">
              <h2 style={{ fontSize: '1.75rem', marginBottom: '1rem' }}>Core Engineering Pillars</h2>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={{ background: 'rgba(11, 15, 23, 0.6)', padding: '1rem', borderRadius: '12px', border: '1px solid var(--border-bento)' }}>
                  <div style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}><FiMonitor /></div>
                  <h4 style={{ fontSize: '1rem', marginBottom: '0.25rem' }}>Clean & Scalable Code</h4>
                  <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', margin: 0 }}>Built with modern React, Next.js, Flutter, Node.js & TypeScript.</p>
                </div>
                <div style={{ background: 'rgba(11, 15, 23, 0.6)', padding: '1rem', borderRadius: '12px', border: '1px solid var(--border-bento)' }}>
                  <div style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}><FiZap /></div>
                  <h4 style={{ fontSize: '1rem', marginBottom: '0.25rem' }}>Agile Sprint Delivery</h4>
                  <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', margin: 0 }}>High-speed 2-week development iterations with clear demos.</p>
                </div>
                <div style={{ background: 'rgba(11, 15, 23, 0.6)', padding: '1rem', borderRadius: '12px', border: '1px solid var(--border-bento)' }}>
                  <div style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}><FiShield /></div>
                  <h4 style={{ fontSize: '1rem', marginBottom: '0.25rem' }}>Bank-Grade Security</h4>
                  <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', margin: 0 }}>256-bit SSL encryption, OWASP standards & secure API design.</p>
                </div>
                <div style={{ background: 'rgba(11, 15, 23, 0.6)', padding: '1rem', borderRadius: '12px', border: '1px solid var(--border-bento)' }}>
                  <div style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}><FaHandshake /></div>
                  <h4 style={{ fontSize: '1rem', marginBottom: '0.25rem' }}>100% IP & Code Ownership</h4>
                  <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', margin: 0 }}>Full ownership of source code and repositories handed to you.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bento-box col-span-4" style={{ marginTop: '2rem', textAlign: 'center', padding: '3.5rem 2rem' }}>
            <h2 className="gradient-text" style={{ fontSize: '2.25rem', marginBottom: '1rem' }}>Our Engineering Track Record</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginTop: '2.5rem' }}>
              <div>
                <div style={{ fontSize: '2.75rem', fontWeight: '900', color: 'var(--color-amber)' }}>120+</div>
                <div style={{ color: 'var(--text-muted)', fontWeight: '600', marginTop: '0.25rem' }}>Projects Delivered</div>
              </div>
              <div>
                <div style={{ fontSize: '2.75rem', fontWeight: '900', color: '#ffffff' }}>40+</div>
                <div style={{ color: 'var(--text-muted)', fontWeight: '600', marginTop: '0.25rem' }}>Happy Business Clients</div>
              </div>
              <div>
                <div style={{ fontSize: '2.75rem', fontWeight: '900', color: 'var(--color-amber)' }}>99.8%</div>
                <div style={{ color: 'var(--text-muted)', fontWeight: '600', marginTop: '0.25rem' }}>On-Time Delivery Rate</div>
              </div>
              <div>
                <div style={{ fontSize: '2.75rem', fontWeight: '900', color: '#ffffff' }}>24/7</div>
                <div style={{ color: 'var(--text-muted)', fontWeight: '600', marginTop: '0.25rem' }}>Dedicated Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
